// extracted by mini-css-extract-plugin
export default {"Title":"VerifiedPopoverTitle_Title__uc8nu"};